import { c as _c } from "react/compiler-runtime";
import { useIsDevTenant } from "@/lib/tenant-utils";

/** SPA Connect (Spakinect) enforces a maximum of 11 treatments per GFE request. */
export const MAX_GFE_TREATMENTS = 11;

/**
 * Hook to get a function that generates Spakinect portal URLs.
 * Automatically determines the correct environment based on tenant type.
 *
 * @returns A function that takes a GFE ID and returns the full Spakinect portal URL
 */
export function useSpakinectPortalUrl() {
  const $ = _c(2);
  const isDevTenant = useIsDevTenant();
  const subdomain = isDevTenant ? "client-test" : "client";
  let t0;
  if ($[0] !== subdomain) {
    t0 = gfeId => `https://${subdomain}.spakinect.com/?gfe=${gfeId}`;
    $[0] = subdomain;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}